import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaFileCircleMinus, FaPencil, FaPlus, FaPrint, FaXmark } from "react-icons/fa6";
import { FaCheck, FaCloudUploadAlt, FaSave, FaSearch } from "react-icons/fa";
import AsyncSelect from 'react-select/async';
import { getData, postData } from "../../../api/ApiRest";
import { formatDateddMMMyyyy } from "../../../widgets/DateTime";
import { formatNumber } from "../../../widgets/FormatNumber";
import LoadingComponent from "../../../widgets/LoadingComponent";
import {
    Box, Paper, Grid, TextField, Button, Typography, Breadcrumbs,
    Tooltip, IconButton, Checkbox, FormControlLabel,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';
import { MdClose } from 'react-icons/md';
import { styled } from '@mui/material/styles';

// ── Estilos de tabla ──────────────────────────────────────────────────────────

const HeaderCell = styled(TableCell)(() => ({
    backgroundColor: '#224B6A',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '0.78rem',
    whiteSpace: 'nowrap',
    padding: '10px 12px',
}));

const BodyCell = styled(TableCell)(() => ({
    fontSize: '0.78rem',
    padding: '7px 12px',
    borderColor: '#dee2e6',
}));

const StyledRow = styled(TableRow)(({ index }) => ({
    backgroundColor: index % 2 === 0 ? '#fff' : '#f8fafc',
    '&:hover': { backgroundColor: 'rgba(144, 203, 216, 0.2)' },
}));

const inputSx = {
    '& .MuiInputBase-input': { fontSize: '0.82rem' },
    '& .MuiInputLabel-root': { fontSize: '0.82rem' },
};

// ── Componente principal ──────────────────────────────────────────────────────

function Factura() {
    const [loading, setLoading] = useState(false);
    const [dataBuscar, setDataBuscar] = useState({});
    const [infoFactura, setInfoFactura] = useState({ ModalVisible: false, Titulo: '' });
    const [modalPlan, setModalPlan] = useState({ ModalVisible: false, Titulo: '' });
    const [dataPlan, setDataPlan] = useState({ planid: '', activo: '', reserva: '', Inicio: '', FinContratado: '' });
    const navigate = useNavigate();
    const [dataFactura, setDataFactura] = useState({
        Fecha: new Date().toISOString().split('T')[0], Cliente: '', PlanId: '', VlrUndFolio: 0, FoliosCantidad: 0, Plan: '', CompanyPlanId: '', Producto: ''
    });
    const [facturas, setFacturas] = useState([]);
    const [frame, setFrame] = useState({ ModalVisible: false, Token: '', Documento: '' });
    const [devoluciones, setDevoluciones] = useState([]);
    const [modalDevolucion, setModalDevolucion] = useState({ ModalVisible: false, Titulo: '' });

    useEffect(() => {
        const fechaActual = new Date();
        fechaActual.setDate(fechaActual.getDate() - 15);
        setDataBuscar({
            ...dataBuscar,
            FechaIni: fechaActual.toISOString().split('T')[0],
            FechaFin: new Date().toISOString().split('T')[0]
        });
    }, [])

    const buscarFacturas = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Configuracion/Factura/buscarFacturas', {
            fechaini: dataBuscar.FechaIni,
            fechafin: dataBuscar.FechaFin,
            numero: dataBuscar.Numero || ''
        }, {}).then(response => {
            if (dataBuscar.Cliente) {
                let valoresFactura = response.facturas.filter(x => Number(x.companyId) === Number(dataBuscar.Cliente));
                setFacturas(valoresFactura);
            } else {
                setFacturas(response.facturas);
            }
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                return response.companies;
            }, error => {
                return [];
            })
    }

    const visualizarFactura = (Documento, Token) => {
        setFrame({ ModalVisible: true, Documento, Token });
    }

    const actualizarPlan = () => {
        setLoading(true);
        const confirma = window.confirm('¿Estas seguro de los cambios a realizar?');
        if (!confirma) { setLoading(false); return; }

        getData('api/Configuracion/Factura/cambiarEstadoPlan', {
            planid: dataPlan.planid,
            activo: dataPlan.activo,
            reserva: dataPlan.reserva,
            fechaIni: dataPlan.Inicio,
            fechaFin: dataPlan.FinContratado
        }).then(response => {
            alert(response.msj);
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const generarFactura = () => {
        setLoading(true);
        getData('api/Configuracion/Factura/generarFactura', {
            Cliente: dataFactura.Cliente,
            Fecha: dataFactura.Fecha,
            PlanId: dataFactura.PlanId,
            prefijo: dataFactura.Prefijo,
            valor: Math.round(dataFactura.FoliosCantidad * dataFactura.VlrUndFolio)
        }).then(response => {
            if (response.status) {
                alert(response.msj);
                setInfoFactura({ ModalVisible: false, Titulo: '' });
            }
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const totalGlobal = (tipo = '') => {
        let total = 0;
        facturas.map((item) => { total += item[tipo] });
        return total;
    }

    const editarFactura = (facturaid) => {
        window.open('/Home/FacturaCRUD/' + facturaid);
    }

    const selectedTodoV2 = (valor) => {
        setDevoluciones(prev => prev.map(item => ({ ...item, selected: valor })));
    }

    const generarDevolucion = async () => {
        let datos = devoluciones.filter(item => item.selected === true);

        for (let i = 0; i < datos.length; i++) {
            const item = datos[i];

            setDevoluciones(prev =>
                prev.map((data) =>
                    (data.prefijo === item.prefijo && data.numero === item.numero) ? { ...data, loading: true } : data
                )
            );

            let peticionPosGolds = {
                Prefijo: item.prefijo, Numero: item.numero, Documento: item.documento,
                Valor: item.valor, Nit: item.nit, Fecha: item.fecha, Tercero: item.tercero,
                Factura: item.factura, Cruce: item.cruce, PrefijoFactura: item.prefijoFactura,
                NumeroFactura: item.numeroFactura
            };

            try {
                await postData('api/Configuracion/Factura/generarDevoluciones', {}, peticionPosGolds)
                    .then(response => {
                        setDevoluciones(prev =>
                            prev.map((data) =>
                                (data.prefijo === item.prefijo && data.numero === item.numero) ?
                                    { ...data, status: response.status, mensaje: response.msj, loading: false } : data
                            )
                        );
                    }, error => {
                        console.log(error);
                        setDevoluciones(prev =>
                            prev.map((data, idx) =>
                                idx === i ? { ...data, status: false, mensaje: error, loading: false } : data
                            )
                        );
                    });
            } catch (error) {
                console.log(error);
            }
        }
    }

    const visualizarDevoluciones = async () => {
        setLoading(true);
        await getData('api/Configuracion/Factura/GetInfoDevolucion', {}).then(response => {
            setDevoluciones(response.list);
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    // ── Render ────────────────────────────────────────────────────────────────

    return (
        <Box sx={{ p: 2 }}>
            {/* Encabezado */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Breadcrumbs sx={{ fontSize: '0.82rem' }}>
                    <Typography color="inherit" fontSize="0.82rem">Home</Typography>
                    <Typography color="text.primary" fontSize="0.82rem">Facturas</Typography>
                </Breadcrumbs>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Tooltip title="Nueva factura">
                        <Button variant="contained" size="small" startIcon={<FaPlus size={11} />}
                            onClick={() => navigate('/Home/FacturaCRUD/0')}
                            sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                            Nueva
                        </Button>
                    </Tooltip>
                    <Tooltip title="Estado plan">
                        <IconButton size="small" color="error"
                            onClick={() => setModalPlan({ Titulo: 'Modificar estado plan', ModalVisible: true })}
                            sx={{ border: '1px solid currentColor' }}>
                            <FaCloudUploadAlt size={14} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Visualizar devoluciones de venta">
                        <IconButton size="small" color="warning"
                            onClick={() => { setModalDevolucion({ Titulo: 'Devoluciones', ModalVisible: true }); visualizarDevoluciones(); }}
                            sx={{ border: '1px solid currentColor' }}>
                            <FaFileCircleMinus size={14} />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>

            <LoadingComponent Loading={loading} />

            {/* Filtros */}
            <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2 }}
                component="form" onSubmit={buscarFacturas}>
                <Grid container spacing={1.5} alignItems="flex-end">
                    <Grid item xs={6} sm={3} md={2}>
                        <TextField label="Fecha Inicial" type="date" fullWidth size="small" sx={inputSx}
                            autoComplete="off" InputLabelProps={{ shrink: true }}
                            value={dataBuscar.FechaIni || ''}
                            onChange={e => setDataBuscar({ ...dataBuscar, FechaIni: e.target.value })} />
                    </Grid>
                    <Grid item xs={6} sm={3} md={2}>
                        <TextField label="Fecha Final" type="date" fullWidth size="small" sx={inputSx}
                            autoComplete="off" InputLabelProps={{ shrink: true }}
                            value={dataBuscar.FechaFin || ''}
                            onChange={e => setDataBuscar({ ...dataBuscar, FechaFin: e.target.value })} />
                    </Grid>
                    <Grid item xs={6} sm={3} md={2}>
                        <TextField label="Número" type="number" fullWidth size="small" sx={inputSx}
                            inputProps={{ min: 0 }}
                            value={dataBuscar.Numero || ''}
                            onChange={e => setDataBuscar({ ...dataBuscar, Numero: e.target.value })} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={5}>
                        <AsyncSelect
                            cacheOptions defaultOptions
                            menuPosition="fixed"
                            noOptionsMessage={() => 'Escriba para iniciar la búsqueda'}
                            placeholder="Cliente"
                            isClearable
                            loadOptions={companieSearchSelect2}
                            onChange={value => setDataBuscar({ ...dataBuscar, Cliente: value ? value.value : '' })}
                            styles={{ control: base => ({ ...base, fontSize: '0.82rem', minHeight: 40 }) }}
                        />
                    </Grid>
                    <Grid item xs={6} sm={2} md={1}>
                        <Button type="submit" variant="contained" size="small"
                            startIcon={<FaSearch size={12} />}
                            sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                            Buscar
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            {/* Tabla de facturas */}
            <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2 }}>
                <Table size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <HeaderCell align="center">Acción</HeaderCell>
                            <HeaderCell align="center">#</HeaderCell>
                            <HeaderCell align="center">Documento</HeaderCell>
                            <HeaderCell align="center">Fecha</HeaderCell>
                            <HeaderCell align="center">Identificación</HeaderCell>
                            <HeaderCell>Cliente</HeaderCell>
                            <HeaderCell align="right">Total</HeaderCell>
                            <HeaderCell align="right">Saldo</HeaderCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {facturas.length === 0 ? (
                            <TableRow>
                                <BodyCell colSpan={8} align="center" sx={{ color: '#9ca3af', py: 4 }}>
                                    Sin resultados.
                                </BodyCell>
                            </TableRow>
                        ) : (
                            <>
                                {facturas.map((item, index) => (
                                    <StyledRow key={index} index={index}>
                                        <BodyCell align="center">
                                            {item.terceroid !== null && (
                                                <Tooltip title="Editar factura">
                                                    <IconButton size="small" sx={{ color: '#1976d2' }}
                                                        onClick={() => editarFactura(item.facturaid)}>
                                                        <FaPencil size={13} />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                            {item.numero !== 0 && (
                                                <Tooltip title="Imprimir">
                                                    <IconButton size="small" sx={{ color: '#f59e0b' }}
                                                        onClick={() => visualizarFactura(item.prefijo + ' - ' + item.numero, item.token)}>
                                                        <FaPrint size={13} />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </BodyCell>
                                        <BodyCell align="center">{index + 1}</BodyCell>
                                        <BodyCell align="center">{item.prefijo} - {item.numero}</BodyCell>
                                        <BodyCell align="center">{formatDateddMMMyyyy(item.fecha)}</BodyCell>
                                        <BodyCell align="center">{item.nit}</BodyCell>
                                        <BodyCell>{item.tercero}</BodyCell>
                                        <BodyCell align="right">$ {formatNumber(item.total)}</BodyCell>
                                        <BodyCell align="right">$ {formatNumber(item.saldofv)}</BodyCell>
                                    </StyledRow>
                                ))}
                                <TableRow sx={{ backgroundColor: '#f1f5f9' }}>
                                    <BodyCell colSpan={6} align="center" sx={{ fontWeight: 'bold' }}>Total</BodyCell>
                                    <BodyCell align="right" sx={{ fontWeight: 'bold' }}>$ {formatNumber(totalGlobal('total'))}</BodyCell>
                                    <BodyCell align="right" sx={{ fontWeight: 'bold' }}>$ {formatNumber(totalGlobal('saldofv'))}</BodyCell>
                                </TableRow>
                            </>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* MODAL: Estado Plan */}
            <Dialog open={modalPlan.ModalVisible}
                onClose={() => { setModalPlan({ ModalVisible: false, Titulo: '' }); setDataPlan({ planid: '', activo: '', reserva: '', Inicio: '', FinContratado: '' }); }}
                maxWidth="md" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#224B6A', color: '#fff', py: 1.5, px: 2 }}>
                    <Typography fontWeight={700} fontSize="0.95rem">{modalPlan.Titulo}</Typography>
                    <IconButton size="small" onClick={() => { setModalPlan({ ModalVisible: false, Titulo: '' }); setDataPlan({ planid: '', activo: '', reserva: '', Inicio: '', FinContratado: '' }); }} sx={{ color: '#fff' }}>
                        <MdClose size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <Grid container spacing={1.5} alignItems="center" sx={{ mt: 0.5 }}>
                        <Grid item xs={12} md={2}>
                            <TextField label="Plan ID" type="number" fullWidth size="small" sx={inputSx}
                                value={dataPlan.planid}
                                onChange={e => setDataPlan({ ...dataPlan, planid: e.target.value })} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField label="Inicio" type="date" fullWidth size="small" sx={inputSx}
                                autoComplete="off" InputLabelProps={{ shrink: true }}
                                value={dataPlan.Inicio}
                                onChange={e => setDataPlan({ ...dataPlan, Inicio: e.target.value })} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField label="Fin contratado" type="date" fullWidth size="small" sx={inputSx}
                                autoComplete="off" InputLabelProps={{ shrink: true }}
                                value={dataPlan.FinContratado}
                                onChange={e => setDataPlan({ ...dataPlan, FinContratado: e.target.value })} />
                        </Grid>
                        <Grid item xs={6} md={1}>
                            <FormControlLabel
                                control={<Checkbox size="small" checked={dataPlan.activo || false}
                                    onChange={e => setDataPlan({ ...dataPlan, activo: e.target.checked })} />}
                                label={<Typography fontSize="0.78rem">Activo</Typography>} />
                        </Grid>
                        <Grid item xs={6} md={1}>
                            <FormControlLabel
                                control={<Checkbox size="small" checked={dataPlan.reserva || false}
                                    onChange={e => setDataPlan({ ...dataPlan, reserva: e.target.checked })} />}
                                label={<Typography fontSize="0.78rem">Reserva</Typography>} />
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <Tooltip title="Guardar">
                                <IconButton size="small" color="success" onClick={actualizarPlan}
                                    sx={{ border: '1px solid currentColor' }}>
                                    <FaSave size={14} />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>

            {/* MODAL: Impresión */}
            <Dialog open={frame.ModalVisible}
                onClose={() => setFrame({ ModalVisible: false, Documento: '', Token: '' })}
                maxWidth="md" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#224B6A', color: '#fff', py: 1.5, px: 2 }}>
                    <Typography fontWeight={700} fontSize="0.95rem">Impresión {frame.Documento}</Typography>
                    <IconButton size="small" onClick={() => setFrame({ ModalVisible: false, Documento: '', Token: '' })} sx={{ color: '#fff' }}>
                        <MdClose size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 0 }}>
                    <iframe
                        src={"http://tae.goldpos.com.co/ReporteApp/Factura/ImprimirFacturaTaecol?documento=" + frame.Token}
                        width="100%" height="450px"
                        style={{ marginTop: 0, border: 'none' }}
                        title="Reporte PDF"
                    />
                </DialogContent>
            </Dialog>

            {/* MODAL: Devoluciones */}
            <Dialog open={modalDevolucion.ModalVisible}
                onClose={() => { setModalDevolucion({ ModalVisible: false, Titulo: '' }); setDevoluciones([]); }}
                maxWidth="xl" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#224B6A', color: '#fff', py: 1.5, px: 2 }}>
                    <Typography fontWeight={700} fontSize="0.95rem">{modalDevolucion.Titulo}</Typography>
                    <IconButton size="small" onClick={() => { setModalDevolucion({ ModalVisible: false, Titulo: '' }); setDevoluciones([]); }} sx={{ color: '#fff' }}>
                        <MdClose size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 0 }}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <HeaderCell align="center">#</HeaderCell>
                                    <HeaderCell align="center">Devolución</HeaderCell>
                                    <HeaderCell align="center">Factura</HeaderCell>
                                    <HeaderCell align="center">Fecha</HeaderCell>
                                    <HeaderCell align="center">Identificación</HeaderCell>
                                    <HeaderCell>Cliente</HeaderCell>
                                    <HeaderCell align="right">Valor</HeaderCell>
                                    <HeaderCell align="center">
                                        <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                                            <Tooltip title="Seleccionar todo (doble clic = deseleccionar)">
                                                <IconButton size="small" sx={{ color: '#fff', border: '1px solid #fff' }}
                                                    onClick={() => selectedTodoV2(true)}
                                                    onDoubleClick={() => selectedTodoV2(false)}>
                                                    <FaCheck size={12} />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Generar devolución">
                                                <IconButton size="small" sx={{ color: '#fff', border: '1px solid #fff' }}
                                                    onClick={generarDevolucion}>
                                                    <FaSave size={12} />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </HeaderCell>
                                    <HeaderCell align="center">Estado</HeaderCell>
                                    <HeaderCell>Mensaje</HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {devoluciones.length === 0 ? (
                                    <TableRow>
                                        <BodyCell colSpan={10} align="center" sx={{ color: '#9ca3af', py: 4 }}>Sin devoluciones.</BodyCell>
                                    </TableRow>
                                ) : devoluciones.map((item, index) => (
                                    <StyledRow key={index} index={index}>
                                        <BodyCell align="center">{index + 1}</BodyCell>
                                        <BodyCell align="center">{item.prefijo} - {item.numero}</BodyCell>
                                        <BodyCell align="center">{item.cruce}</BodyCell>
                                        <BodyCell align="center">{formatDateddMMMyyyy(item.fecha)}</BodyCell>
                                        <BodyCell align="center">{item.nit}</BodyCell>
                                        <BodyCell>{item.tercero}</BodyCell>
                                        <BodyCell align="right">$ {formatNumber(item.valor)}</BodyCell>
                                        <BodyCell align="center">
                                            <Checkbox size="small" checked={item.selected || false}
                                                onChange={() => setDevoluciones(
                                                    devoluciones.map(p => p.prefijo === item.prefijo && p.numero === item.numero
                                                        ? { ...p, selected: !item.selected } : p)
                                                )} />
                                        </BodyCell>
                                        <BodyCell align="center">
                                            {item.loading
                                                ? <img alt="loading" src="/tav-loading.gif" style={{ width: 20 }} />
                                                : item.status ? <FaCheck size={14} color="#16a34a" /> : <FaXmark size={14} color="#dc2626" />
                                            }
                                        </BodyCell>
                                        <BodyCell>{item.mensaje}</BodyCell>
                                    </StyledRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
            </Dialog>

            {/* MODAL: Generar factura */}
            <Dialog open={infoFactura.ModalVisible}
                onClose={() => { setInfoFactura({ ModalVisible: false, Titulo: '' }); setDataFactura({ Fecha: new Date().toISOString().split('T')[0], Cliente: '', PlanId: '', VlrUndFolio: 0, FoliosCantidad: 0, Plan: '', CompanyPlanId: '' }); }}
                maxWidth="md" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#224B6A', color: '#fff', py: 1.5, px: 2 }}>
                    <Typography fontWeight={700} fontSize="0.95rem">{infoFactura.Titulo}</Typography>
                    <IconButton size="small" onClick={() => { setInfoFactura({ ModalVisible: false, Titulo: '' }); setDataFactura({ Fecha: new Date().toISOString().split('T')[0], Cliente: '', PlanId: '', VlrUndFolio: 0, FoliosCantidad: 0, Plan: '', CompanyPlanId: '' }); }} sx={{ color: '#fff' }}>
                        <MdClose size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <Grid container spacing={1.5} alignItems="center" sx={{ mt: 0.5 }}>
                        <Grid item xs={12} md={3}>
                            <TextField label="Fecha" type="date" fullWidth size="small" sx={inputSx}
                                InputLabelProps={{ shrink: true }}
                                value={dataFactura.Fecha}
                                onChange={e => setDataFactura({ ...dataFactura, Fecha: e.target.value })} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField label="Prefijo" fullWidth size="small" sx={inputSx}
                                value={dataFactura.Prefijo || ''}
                                onChange={e => setDataFactura({ ...dataFactura, Prefijo: e.target.value })} />
                        </Grid>
                        <Grid item xs="auto">
                            <Tooltip title="Generar factura">
                                <IconButton size="small" color="success" onClick={generarFactura}
                                    sx={{ border: '1px solid currentColor' }}>
                                    <FaPlus size={14} />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </Box>
    );
}

export default Factura;
